import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { CookieService } from 'ngx-cookie-service';
import { GetDataService } from './shared/services/getdata.service';
import { AccessType2 } from './shared/enums/enum.type';
import { AppLevelAccess } from './shared/models/models';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  constructor(private router: Router, private cookieService:CookieService,private dataService:GetDataService,
    private commonService:CommonService){}

  ngOnInit(): void {
    console.log('version --001/01');
    this.authenticateUser();
    this.getBaseDetails();

    // direct login from parent app
    this.directLoginFromParent();
  }


  authenticateUser(){
    const persistant = firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    console.log('persistant',persistant);
    firebase.auth().onAuthStateChanged((_user) => {
      if (_user) {
      } else {
        if(!this.router.url.includes("auth/forget-password") && (!this.router.url.includes("login") || !this.router.url.includes("register") || !this.router.url.includes("404"))){
          const redirectRoute= localStorage.getItem('redirectRoute');
          localStorage.clear();
          redirectRoute?localStorage.setItem('redirectRoute',redirectRoute):'';
          this.router.navigateByUrl("/auth/login");
        }
      }
    });
  }

  
  getBaseDetails=()=>{
    const baseLevelAccess = this.cookieService.get('baseLevelAccess');
    const matiAdminEmail = localStorage.getItem('mati_admin_email')
    if(matiAdminEmail && (!baseLevelAccess)){
      this.dataService.checkAdminExistence(matiAdminEmail).subscribe(response=>{
        if(response && response.data && response.data.length>0){
          const baseLevelAcessObj = response.data[0].base_details;
          if(baseLevelAcessObj){
            let appLevelAccess: AppLevelAccess[]=[];
            baseLevelAcessObj.forEach((item:any)=>{
              appLevelAccess.push({baseId:item.base_id,accessLevel:{farmApp:item.farm_app_access,warehouse:item.warehouse_app_access,
                labApp:item.lab_app_access,supplyDemand:item.supply_demand_access,
                qualityAccess:item.quality_system_access,qualityInternalAccess:item.quality_system_edit_internal_access,
                hseAccess:item.hse_system_access,hseSummaryAccess:item.hse_summary_view,hseReportAccess:item.hse_report_view}});
            });
            this.commonService.setAppLevelAccess(appLevelAccess);
            this.cookieService.set('baseLevelAccess',JSON.stringify(appLevelAccess));
          }

          // ask for current base access switch

        }
      })
    }
    if(baseLevelAccess){
      const baseLevelAccessJson = JSON.parse(baseLevelAccess);
      this.commonService.setAppLevelAccess(baseLevelAccessJson);
    }
    console.log('baseLevelAccess',baseLevelAccess);
  }

  directLoginFromParent(){
    const matiAdminToken = localStorage.getItem('matiAdminToken');
    const userLoggedIn = localStorage.getItem('userLoggedIn');
    const credential = firebase.auth.GoogleAuthProvider.credential(null, matiAdminToken); // Creates a credential
    const auth = firebase.auth();
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log("User already logged in:", user);
      } else {
        console.error("User not authenticated");
      }
    });
    if(auth && matiAdminToken && !userLoggedIn){
      // auth.signInWithCredential(credential).then((user)=>{
      //   console.log('user',user);
      //   localStorage.setItem('userLoggedIn','true');
      // }).catch((error)=>{
      //   console.log('error',error,credential,matiAdminToken);
      //   localStorage.removeItem('userLoggedIn');
      // })
      firebase.auth().signInWithCustomToken(matiAdminToken).then((user)=>{
        console.log('user',user);
        localStorage.setItem('userLoggedIn','true');
      }).catch((error)=>{
        console.log('error',error,matiAdminToken);
        localStorage.removeItem('userLoggedIn');
      })
    }
  }
}
